import { useCallback, useMemo } from "react";
import { useLocalStorage } from "react-use";

import { STORAGE_WORKSPACE_INFO } from "globalConstants/storage";
import { getItem, removeItem, setItem } from "utils/localStorage";

import type { IManageWorkspaceInfo, TWorkspaceInfo, UseWorkspacePayload } from "./types";

const useWorkspace = (): UseWorkspacePayload => {
  const [workspaceInfo, setWorkspaceInfo, clearWorkspaceInfo] = useLocalStorage<TWorkspaceInfo>(STORAGE_WORKSPACE_INFO);

  const getWorkspaceInfo = useCallback(() => {
    const info = localStorage.getItem(STORAGE_WORKSPACE_INFO);

    if (info) {
      return JSON.parse(info);
    }

    return null;
  }, []);

  const payload = useMemo(
    () => ({ workspaceInfo, setWorkspaceInfo, clearWorkspaceInfo, getWorkspaceInfo }),
    [workspaceInfo, setWorkspaceInfo, clearWorkspaceInfo, getWorkspaceInfo],
  );

  return payload;
};

export const getManagedWorkspaceInfo = (): IManageWorkspaceInfo => {
  const workspaceInfo = getItem(STORAGE_WORKSPACE_INFO);

  const setWorkspaceInfo = (newWorkspaceInfo: TWorkspaceInfo): void => {
    setItem(STORAGE_WORKSPACE_INFO, JSON.stringify(newWorkspaceInfo));
  };
  const getWorkspaceInfo = (): string | null => getItem(STORAGE_WORKSPACE_INFO);
  const clearWorkspaceInfo = (): void => removeItem(STORAGE_WORKSPACE_INFO);

  const payload = { workspaceInfo, getWorkspaceInfo, setWorkspaceInfo, clearWorkspaceInfo };

  return payload;
};

export default useWorkspace;
